"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _defaultShortNumberFormatter = _interopRequireDefault(require("../label-formatters/default-short-number-formatter"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartTwoYaxisLineOptions = _interopRequireDefault(require("./mw-chart-two-yaxis-line-options"));

var _mwChartTwoYaxisLineTooltipOptions = _interopRequireDefault(require("./mw-chart-two-yaxis-line-tooltip-options"));

var _twoSeriesChartData = _interopRequireDefault(require("../two-series-chart-data"));

var _styles = require("../styles");

var NEVER_GO_BELOW_ZERO = 0;
var DATA_POINT_BORDER_COLOR = '#ffffff';

function allKeysAreEqual(seriesOneXData, seriesTwoXData) {
  if (seriesOneXData.length !== seriesTwoXData.length) {
    return false;
  }

  for (var index = 0; index < seriesOneXData.length; index++) {
    if (seriesOneXData[index].key !== seriesTwoXData[index].key) {
      return false;
    }
  }

  return true;
}

function twoSeriesChartDataToHighchartsData(twoSeriesChartData) {
  var leftYAxisData = twoSeriesChartData.seriesOne.data.map(function (point) {
    return point.value;
  });
  var rightYAxisData = twoSeriesChartData.seriesTwo.data.map(function (point) {
    return point.value;
  });

  if (!allKeysAreEqual(twoSeriesChartData.seriesOne.data, twoSeriesChartData.seriesTwo.data)) {
    throw new Error("All key values must be identical for seriesOne and seriesTwo. Provided values: ".concat(JSON.stringify(twoSeriesChartData)));
  }

  var categories = twoSeriesChartData.seriesOne.data.map(function (point) {
    return point.key;
  });
  return {
    categories: categories,
    leftYAxisData: leftYAxisData,
    rightYAxisData: rightYAxisData
  };
}
/**
 * A class for rendering a chart with two y axis
 */


var TwoYAxisLineChart =
/*#__PURE__*/
function () {
  /**
   * Create a new Two Y Axis Line Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function TwoYAxisLineChart(renderTarget) {
    (0, _classCallCheck2.default)(this, TwoYAxisLineChart);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {TwoSeriesChartData} changedChartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(TwoYAxisLineChart, [{
    key: "setChartData",
    value: function setChartData(changedChartData) {
      this.__chartData = (0, _coerce.default)(changedChartData, _twoSeriesChartData.default, "chartData must be a valid TwoSeriesChartData object. Provided value: ".concat(changedChartData));
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartTwoYAxisLineOptions} changedChartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(changedChartOptions) {
      var onError = changedChartOptions.onError;

      if (typeof onError !== 'function') {
        onError = function onError() {};
      }

      var onPointClick = changedChartOptions.onPointClick;

      if (typeof onPointClick !== 'function') {
        onPointClick = function onPointClick() {};
      }

      var chartOptions = Object.assign({}, changedChartOptions, {
        onError: onError,
        onPointClick: onPointClick
      });
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartTwoYaxisLineOptions.default, "chartOptions must be a valid MwChartTwoYAxisLineOptions object. Provided value: ".concat(chartOptions));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      try {
        this.error = false;
        var safeChartData = this.__chartData;
        var leftYAxisTitle = safeChartData.seriesOne.name;
        var rightYAxisTitle = safeChartData.seriesTwo.name;
        var highchartData = twoSeriesChartDataToHighchartsData(safeChartData);
        var categories = highchartData.categories;
        var leftYAxisData = highchartData.leftYAxisData;
        var rightYAxisData = highchartData.rightYAxisData;
        var safeHighchartOptions = this.__chartOptions;
        var onPointClickCallback = safeHighchartOptions.onPointClick;

        if (!this.__renderTarget) {
          throw new Error('Parent container needs to have a non zero "offsetHeight" property');
        }

        var safeXAxisLabelFormatter;

        if (safeHighchartOptions.xAxisLabelFormatter) {
          safeXAxisLabelFormatter = function safeXAxisLabelFormatter() {
            var options = new _axisLabelFormatterOptions.default({
              /* eslint-disable no-invalid-this */
              isFirst: this.isFirst,
              isLast: this.isLast,
              value: this.value
              /* eslint-enable no-invalid-this */

            });
            return safeHighchartOptions.xAxisLabelFormatter(options);
          };
        }

        _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            height: this.__renderTarget.offsetHeight,
            reflow: false,
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          legend: {
            enabled: true,
            symbolWidth: 8,
            itemStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR,
              fontFamily: _styles.FONT_FAMILY,
              fontSize: _styles.LEGEND_LABEL_FONT_SIZE,
              fontWeight: _styles.LEGEND_LABEL_FONT_WEIGHT
            },
            itemHoverStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR
            }
          },
          xAxis: [{
            categories: categories,
            crosshair: false,
            tickWidth: safeHighchartOptions.xAxisTickWidth,
            tickLength: safeHighchartOptions.xAxisTickLength,
            tickColor: _styles.LINE_AND_TICK_COLOR,
            lineWidth: 1,
            lineColor: _styles.LINE_AND_TICK_COLOR,
            labels: {
              step: safeHighchartOptions.xAxisLabelStep,
              formatter: safeXAxisLabelFormatter
            }
          }],
          yAxis: [{
            labels: {
              style: {
                color: safeHighchartOptions.leftYAxisLineColor,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              },
              formatter: function formatter() {
                return (0, _defaultShortNumberFormatter.default)(this.value);
              }
            },
            title: {
              text: leftYAxisTitle,
              style: {
                color: safeHighchartOptions.leftYAxisLineColor,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            },
            floor: NEVER_GO_BELOW_ZERO,
            tickWidth: 1,
            tickLength: 4,
            tickColor: _styles.LINE_AND_TICK_COLOR,
            lineWidth: 1,
            lineColor: _styles.LINE_AND_TICK_COLOR,
            gridLineWidth: 0
          }, {
            opposite: true,
            labels: {
              style: {
                color: safeHighchartOptions.rightYAxisLineColor,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              },
              formatter: function formatter() {
                return (0, _defaultShortNumberFormatter.default)(this.value);
              }
            },
            title: {
              text: rightYAxisTitle,
              style: {
                color: safeHighchartOptions.rightYAxisLineColor,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            },
            floor: NEVER_GO_BELOW_ZERO,
            tickWidth: 1,
            tickLength: 4,
            tickColor: _styles.LINE_AND_TICK_COLOR,
            lineWidth: 1,
            lineColor: _styles.LINE_AND_TICK_COLOR,
            gridLineWidth: 0
          }],
          tooltip: {
            formatter: function formatter() {
              var options = new _mwChartTwoYaxisLineTooltipOptions.default({
                point: this.point,
                series: this.series
              });
              return safeHighchartOptions.tooltipFormatter(options);
            },
            shared: false,
            useHTML: true
          },
          plotOptions: {
            series: {
              animation: safeHighchartOptions.animate,
              cursor: 'pointer',
              dataLabels: {
                enabled: safeHighchartOptions.areDataLabelsVisible,
                formatter: function formatter() {
                  return (0, _defaultShortNumberFormatter.default)(this.y);
                },
                style: {
                  fontFamily: _styles.FONT_FAMILY,
                  fontWeight: _styles.POINT_LABEL_FONT_WEIGHT
                }
              },
              events: {
                click: function click(event) {
                  try {
                    onPointClickCallback({
                      key: event.point.category,
                      keyIndex: event.point.x,
                      seriesName: event.point.series.name,
                      value: event.point.y
                    });
                  } catch (error) {
                    _logger.default.error("Error occured during onPointClick! Error: ".concat(error.message));
                  }
                }
              },
              marker: {
                enabled: null,
                symbol: 'circle',
                radius: 5,
                lineColor: DATA_POINT_BORDER_COLOR,
                lineWidth: 2
              },
              states: {
                hover: {
                  halo: {
                    size: 12
                  }
                }
              }
            }
          },
          series: [{
            name: leftYAxisTitle,
            type: 'spline',
            color: safeHighchartOptions.leftYAxisLineColor,
            data: leftYAxisData,
            tooltip: {
              valueSuffix: ' joes'
            }
          }, {
            yAxis: 1,
            name: rightYAxisTitle,
            type: 'spline',
            color: safeHighchartOptions.rightYAxisLineColor,
            data: rightYAxisData,
            tooltip: {
              valueSuffix: ' andys'
            }
          }]
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
  }]);
  return TwoYAxisLineChart;
}();

exports.default = TwoYAxisLineChart;